import React, { useState, useEffect } from 'react';
import { useGlobalContext } from '../GlobalContext';
import { perkiraankhusus, perkiraan } from "../services/PerkiraanService";  // ✅ import service

const TransferAngsuran = () => {
  const { api } = useGlobalContext();

  const [tglTransaksi, setTglTransaksi] = useState('');
  const [data, setData] = useState([]);
  const [checkedItems, setCheckedItems] = useState([]);
  const [jurnalData, setJurnalData] = useState([]);
  const [piutang, setPiutang] = useState("");
  const [noJurnal, setNoJurnal] = useState("");

  useEffect(() => {
    const today = new Date().toISOString().slice(0, 10);
    setTglTransaksi(today);
  }, []);

  const fetchData = async () => {
    if (!tglTransaksi) {
      alert("Silakan pilih tanggal terlebih dahulu.");
      return;
    }
    if (!piutang) {
      alert("Silakan pilih piutang terlebih dahulu.");
      return;
    }

    try {
      const response = await api.get(`/api/akuntansi/transferangsuran/${tglTransaksi}`);
      setData(response.data);
      setCheckedItems(new Array(response.data.length).fill(false));
    } catch (err) {
      alert('Gagal mengambil data transfer Angsuran');
      console.error(err);
    }
  };

  const handleCheckChange = (index) => {
    const updated = [...checkedItems];
    updated[index] = !updated[index];
    setCheckedItems(updated);
  };

  const handleCekAll = () => {
    setCheckedItems(new Array(data.length).fill(true));
  };

  const handleUncekAll = () => {
    setCheckedItems(new Array(data.length).fill(false));
  };

  const handleProsesJurnal = async () => {
  const selected = data.filter((_, idx) => checkedItems[idx]);

  if (selected.length === 0) {
    alert('Silakan centang minimal satu data untuk memproses jurnal.');
    return;
  }

const [year, month] = tglTransaksi.split("-");
  const periode = `${month}.${year.slice(-2)}`; 
  const kode = "JT";

  try {
    const res = await api.get(`/api/akuntansi/getnourutjurnal/${kode}/${periode}`);
    setNoJurnal(res.data.jnobukti);  
  } catch (err) {
    console.error("❌ Gagal ambil nomor jurnal:", err);
    alert("Tidak bisa ambil nomor jurnal otomatis");
    return;
  }

  const totalAngsuran = selected.reduce((acc, item) => acc + (item.angsuran_d || 0), 0);
  const totalJasa = selected.reduce((acc, item) => acc + (item.jasa_d || 0), 0);
  const totalMenabung = selected.reduce((acc, item) => acc + (item.germen_d || 0), 0);
  const totalKas = totalAngsuran + totalJasa + totalMenabung;

  const [kdKas, kdPiutang, kdJasa, kdGermen] = await Promise.all([
    perkiraankhusus(api, "kas"),       
    perkiraankhusus(api, "piutangD"),  
    perkiraankhusus(api, "jasaD"),   
    perkiraankhusus(api, "germenD")
  ]);

  const [perkKas, perkPiutang, perkJasa, perkGermen] = await Promise.all([
    perkiraan(api, kdKas),
    perkiraan(api, kdPiutang),
    perkiraan(api, kdJasa),
    perkiraan(api, kdGermen),
  ]);

  const jurnal = [];

  if (totalKas > 0) {
    jurnal.push({
      kdperk: kdKas,
      uraianperk: perkKas || "Kas",
      debet: totalKas,
      kredit: 0,
    });
  }

  if (totalAngsuran > 0) {
    jurnal.push({
      kdperk: kdPiutang,
      uraianperk: perkPiutang || "Piutang Debet",
      debet: 0,
      kredit: totalAngsuran,
    });
  }

  if (totalJasa > 0) {
    jurnal.push({
      kdperk: kdJasa,
      uraianperk: perkJasa || "Pendapatan Jasa",
      debet: 0,
      kredit: totalJasa,
    });
  }

  if (totalMenabung > 0) {
    jurnal.push({
      kdperk: kdGermen,
      uraianperk: perkGermen || "Germen",
      debet: 0,
      kredit: totalMenabung,
    });
  }

  setJurnalData(jurnal);
};

  const handleBatalProsesJurnal = () => {
    setJurnalData([]);
          setNoJurnal("");
  };

  const handleSave = async () => {
    const selectedNotransaksi = data
      .filter((_, idx) => checkedItems[idx])
      .map((item) => item.notransaksi);

    if (selectedNotransaksi.length === 0) {
      alert("Pilih minimal satu transaksi untuk disimpan");
      return;
    }

    if (jurnalData.length === 0) {
      alert("Belum ada data jurnal untuk disimpan.");
      return;
    }

    try {
      await api.post("/api/akuntansi/savejurnalangsuran", {
        notransaksiList: selectedNotransaksi,
      });

      const payload = {
        jnobukti: noJurnal,
        jtanggal: tglTransaksi,
        uraian1: "Transfer Angsuran",
        details: jurnalData.map((row) => ({
          jnobukti: noJurnal,
          kdperk: row.kdperk,
          uraianperk: row.uraianperk,
          debet: parseFloat(row.debet),
          kredit: parseFloat(row.kredit),
        })),
      };

      await api.post("/api/akuntansi/savetransfer", payload);

      alert("Jurnal & Transfer Angsuran berhasil disimpan ");

      setData((prev) =>
        prev.map((item) =>
          selectedNotransaksi.includes(item.notransaksi)
            ? { ...item, jurnal: 1 }
            : item
        )
      );

      setCheckedItems(new Array(data.length).fill(false));
      setJurnalData([]);
      setNoJurnal("");

    } catch (err) {
      console.error("❌ Gagal menyimpan:", err);
      alert(err.response?.data?.message || "Gagal menyimpan data");
    }
  };

  const totalAngsuran = data.reduce((acc, item) => acc + (item.angsuran_d || 0), 0);
  const totalJasa = data.reduce((acc, item) => acc + (item.jasa_d || 0), 0);
  const totalMenabung = data.reduce((acc, item) => acc + (item.germen_d || 0), 0);

  return (
    <div className="container mt-4">
      <div className="card">
        <div className="card-header bg-info text-white">
          <h5 className="mb-0">Transfer Angsuran</h5>
        </div>

        <div className="card-body">

          {/* Filter Tanggal + Piutang */}
          <div className="card mb-3">
            <div className="card-body">
              <div className="form-inline">
                <label className="mr-2 font-weight-bold">Tanggal Transaksi</label>
                <input
                  type="date"
                  className="form-control mr-2"
                  value={tglTransaksi}
                  onChange={(e) => setTglTransaksi(e.target.value)}
                />

                <label className="mr-2 font-weight-bold">Piutang</label>
                <select
                  className="form-control mr-2"
                  value={piutang}
                  onChange={(e) => setPiutang(e.target.value)}
                >
                  <option value="">-- Pilih Piutang --</option>
                  <option value="Piutang Angsuran">Piutang D</option>
                </select>

                <button onClick={fetchData} className="btn btn-primary">Display</button>
              </div>
            </div>
          </div>

          {/* Tabel Transfer Angsuran */}
          <div className="card">
            <div className="card-body">
              <table className="table table-bordered table-sm">
                <thead className="thead-light">
                  <tr>
                    <th>Cek</th>
                    <th>Tanggal</th>
                    <th>No. Transaksi</th>
                    <th>No Anggota</th>
                    <th>Nama</th>
                    <th>Angsuran</th>
                    <th>Jasa</th>
                    <th>G. Menabung</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item, idx) => {
                    const isDisabled = item.jurnal === 1; 
                    return (
                      <tr
                        key={idx}
                        className={isDisabled ? "table-secondary" : ""} 
                      >
                        <td className="text-center">
                          <input
                            type="checkbox"
                            checked={checkedItems[idx] || false}
                            onChange={() => handleCheckChange(idx)}
                            disabled={isDisabled} 
                          />
                        </td>
                        <td>{item.tanggal?.split("T")[0]}</td>
                        <td>{item.notransaksi}</td>
                        <td>{item.noanggota}</td>
                        <td>{item.nama}</td>
                        <td className="text-right">
                          {item.angsuran_d?.toLocaleString("id-ID") || "0"}
                        </td>
                        <td className="text-right">
                          {item.jasa_d?.toLocaleString("id-ID") || "0"}
                        </td>
                        <td className="text-right">
                          {item.germen_d?.toLocaleString("id-ID") || "0"}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
                <tfoot>
                  <tr>
                    <td colSpan="5" className="text-center font-weight-bold">Total</td>
                    <td className="text-right font-weight-bold">{totalAngsuran.toLocaleString('id-ID')}</td>
                    <td className="text-right font-weight-bold">{totalJasa.toLocaleString('id-ID')}</td>
                    <td className="text-right font-weight-bold">{totalMenabung.toLocaleString('id-ID')}</td>
                  </tr>
                </tfoot>
              </table>

              <div className="mt-3 d-flex gap-2">
                <button className="btn btn-secondary btn-sm" onClick={handleCekAll}>Cek All</button>&nbsp;
                <button className="btn btn-secondary btn-sm" onClick={handleUncekAll}>Uncek</button>&nbsp;
                <button className="btn btn-success btn-sm" onClick={handleProsesJurnal}>Proses Jurnal</button>&nbsp;
                <button className="btn btn-danger btn-sm" onClick={handleBatalProsesJurnal}>Batal Proses Jurnal</button>
              </div>
            </div>
          </div>

          {/* Form Jurnal */}
          <div className="card mt-4">
            <div className="card-header bg-warning">
              <strong>Form Jurnal</strong>
            </div>
            <div className="card-body">
              <div className="mb-4 border p-3">
                <div className="form-group row">
                  <label className="col-sm-2 col-form-label">No. Jurnal</label>
                  <div className="col-sm-10">
                     <input
                    type="text"
                    className="form-control"
                    placeholder="No. Jurnal"
                    value={noJurnal}
                    onChange={(e) => setNoJurnal(e.target.value)}
                  />
                  </div>
                </div>

                <div className="form-group row">
                  <label className="col-sm-2 col-form-label">Tanggal</label>
                  <div className="col-sm-10">
                    <input
                      type="text"
                      className="form-control"
                      readOnly
                      value={tglTransaksi}
                    />
                  </div>
                </div>

                <div className="form-group row">
                  <label className="col-sm-2 col-form-label">Keterangan</label>
                  <div className="col-sm-10">
                    <input type="text" className="form-control" placeholder="Keterangan" />
                  </div>
                </div>

                <table className="table table-bordered table-sm">
  <thead className="thead-light text-center">
    <tr>
      <th>No. Perk</th>
      <th>Perkiraan</th>
      <th>Debet</th>
      <th>Kredit</th>
    </tr>
  </thead>
  <tbody>
    {jurnalData.length > 0 ? (
      jurnalData.map((row, i) => (
        <tr key={i}>
          <td className="text-center">{row.kdperk}</td>
          <td>{row.uraianperk.trim()}</td>
          <td className="text-right">
            {parseFloat(row.debet).toLocaleString('id-ID')}
          </td>
          <td className="text-right">
            {parseFloat(row.kredit).toLocaleString('id-ID')}
          </td>
        </tr>
      ))
    ) : (
      <tr>
        <td colSpan="4" className="text-center text-muted">
          Belum ada data jurnal.
        </td>
      </tr>
    )}
  </tbody>
  {jurnalData.length > 0 && (
    <tfoot>
      <tr className="font-weight-bold">
        <td colSpan="2" className="text-center">
          Total
        </td>
        <td className="text-right">
          {jurnalData
            .reduce((acc, row) => acc + parseFloat(row.debet), 0)
            .toLocaleString('id-ID')}
        </td>
        <td className="text-right">
          {jurnalData
            .reduce((acc, row) => acc + parseFloat(row.kredit), 0)
            .toLocaleString('id-ID')}
        </td>
      </tr>
    </tfoot>
  )}
</table>

{/* tombol Save diletakkan DI LUAR table */}
{jurnalData.length > 0 && (
  <div className="mt-3 text-right">
    <button className="btn btn-primary" onClick={handleSave}>
      Save
    </button>
  </div>
)}

              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default TransferAngsuran;
